import React from 'react';

const BtnStandard = ({label,click}) => {
    return (
        <button onClick={()=>click&&click()} className='btn-standard fs15 fr w100'>
            {label}
        </button>
    );
};

export default BtnStandard;